
import { clearPartnerDues } from "../Util/queries";
import { getLastMonthBilling } from "./lastMonthBillingAction";

export const clearLastMonthBilling = (partnerId) => async (dispatch) => {
    try {
        await clearPartnerDues(partnerId);
    } catch (e) {
        console.error(e);
    }

    dispatch(getLastMonthBilling());
};